import amplitude from '@/amplitude'

enum Event {
  viewOrderClicked = 'View Order Clicked',
  addItemsClicked = 'Add Items Clicked',
  cancelTabClicked = 'Cancel Tab Clicked',
  selectTableClicked = 'Select Table Clicked',
  tableConfirmed = 'Table Confirmed',
  trashItemClicked = 'Trash Item Clicked',
  paymentMethodClicked = 'Payment Method Clicked',
  addPaymentMethodClicked = 'Add Payment Method Clicked',
  nextButtonClicked = 'Next Button Clicked',
  submitOrderClicked = 'Submit Order Clicked',
  orderSubmittedSuccessfully = 'Order Submitted Successfully',
}

const track = (event: Event, attributes: Record<string, any>) => {
  amplitude.track(event, attributes)
}

export const viewOrderClicked = () => {
  track(Event.viewOrderClicked, {})
}

export const addItemsClicked = () => {
  track(Event.addItemsClicked, {})
}

export const cancelTabClicked = () => {
  track(Event.cancelTabClicked, {})
}

export const selectTableClicked = () => {
  track(Event.selectTableClicked, {})
}

export const tableConfirmed = (tableId: number) => {
  track(Event.tableConfirmed, { tableId })
}

export const trashItemClicked = () => {
  track(Event.trashItemClicked, {})
}

export const paymentMethodClicked = () => {
  track(Event.paymentMethodClicked, {})
}

export const addPaymentMethodClicked = () => {
  track(Event.addPaymentMethodClicked, {})
}

export const nextButtonClicked = () => {
  track(Event.nextButtonClicked, {})
}

export const submitOrderClicked = () => {
  track(Event.submitOrderClicked, {})
}

export const orderSubmittedSuccessfully = (orderTotal: number, itemCount: number, sessionId: string) => {
  track(Event.orderSubmittedSuccessfully, { orderTotal, itemCount, sessionId })
}
